import React from 'react';

import BaseComponent from 'src/components/BaseComponent';

import { withRouter } from 'src/helpers';
import model from './model';

import Patient from './Patient';
import Doctor from './Doctor';
import Clinic from './Clinic';

class Index extends BaseComponent {
  componentDidMount() {
    model.resetPersonal();
    model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  render() {
    return model.user?.isDoctor ? (
      <Doctor key={this.props.language} />
    ) : model.user?.isClinic ? (
      <Clinic key={this.props.language} />
    ) : (
      <Patient key={this.props.language} />
    );
  }
}

export default withRouter(Index);
